import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import MUIDataTable from 'mui-datatables';
import React, { Fragment } from 'react';

import { NoForms } from './NoForms';
import Print from './Print';

const theme = createTheme({
  overrides: {
    MuiTableRow: {
      root: {
        '&$hover:hover': {
          cursor: 'pointer',
        },
      },
    },
    MuiTableCell: {
      root: {
        padding: '0 0 0 16px',
        height: '47px',
      },
    },
  },
});

const Builder = (props) => {
  const {
    data,
    exportEnabled,
    mode,
    onRowClick,
    onExportForm,
    onEditFormDetails,
    onDuplicateForm,
    onDeleteForm,
  } = props;
  let options = {
    elevation: 0,
    viewColumns: false,
    selectableRows: 'none',
    responsive: 'standard',
    rowsPerPage: 15,
    download: false,
    onCellClick: ((data, _colData, cellMeta) => {
      // skip the action menu cell click
      if (cellMeta.colIndex === 6) {
        return;
      }
      const rowData = data[cellMeta.dataIndex];
      onRowClick({ rowData });
    }).bind(this, data),
  };

  if (mode === 'builder' && Boolean(exportEnabled)) {
    options.customToolbar = () => {
      return (
        <Fragment>
          <Tooltip title="Export All Data (raw)">
            <IconButton onClick={() => onExportForm('raw')}>
              <CloudDownloadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Export All Data (labeled)">
            <IconButton onClick={() => onExportForm('label')}>
              <CloudDownloadIcon />
            </IconButton>
          </Tooltip>
        </Fragment>
      );
    };
  }
  const actionsRenderer = (_value, tableMeta) => {
    return (
      <PopupState variant="popover" popupId="popup-menu">
        {(popupState) => (
          <div>
            <IconButton
              aria-label="action menu"
              title="Action Menu"
              {...bindTrigger(popupState)}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu {...bindMenu(popupState)}>
              <MenuItem
                onClick={() => {
                  popupState.close();
                  onEditFormDetails(tableMeta);
                }}
              >
                Edit Details
              </MenuItem>
              <MenuItem onClick={() => onDuplicateForm(tableMeta)}>
                Duplicate
              </MenuItem>
              <MenuItem
                onClick={() => {
                  popupState.close();
                }}
              >
                <Print
                  title={tableMeta.rowData[1]}
                  form={tableMeta.rowData[5]}
                ></Print>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  popupState.close();
                  onDeleteForm(tableMeta);
                }}
              >
                Delete
              </MenuItem>
            </Menu>
          </div>
        )}
      </PopupState>
    );
  };

  const columns = [
    { name: 'containerType', label: 'Hierarchy Level' },
    { name: 'name', label: 'Form Name' },
    { name: 'key', label: 'Form Key' },
    { name: 'fields', label: 'Fields' },
    { name: 'description', label: 'Description' },
    { name: 'formDef', label: 'Form Def', options: { display: false } },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        customBodyRender: actionsRenderer,
        display: mode === 'builder',
      },
    },
  ];

  return (
    <Fragment>
      {data.length ? (
        <ThemeProvider theme={theme}>
          <div style={{ width: '100vw' }}>
            <MUIDataTable
              data={data}
              columns={columns}
              options={options}
            ></MUIDataTable>
          </div>
        </ThemeProvider>
      ) : (
        <NoForms></NoForms>
      )}
    </Fragment>
  );
};

export default Builder;
